export default "__VITE_ASSET__DHDW6NZN__"